
import Vue from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default Vue.extend({
  components: {
    PulseLoader,
  },
  props: {
    Text: String,
    Icon: {
      type: String,
      default: "$vuetify.icons.cancel",
    },
    isBusy: Boolean,
    HasCallRights: Boolean
  },
  computed: {
    HasNoCallRights: function() : boolean
    {
      return this.HasCallRights == false;
    }
  },
  methods: {
    Click() {
      this.$emit("click");
    },
  },
});
